export const CHECK_REQUIRED_PROFILE_ATTEMPT = 'CHECK_REQUIRED_PROFILE_ATTEMPT';
export type CHECK_REQUIRED_PROFILE_ATTEMPT = typeof CHECK_REQUIRED_PROFILE_ATTEMPT;

export const CHECK_REQUIRED_PROFILE_SUCCESS = 'CHECK_REQUIRED_PROFILE_SUCCESS';
export type CHECK_REQUIRED_PROFILE_SUCCESS = typeof CHECK_REQUIRED_PROFILE_SUCCESS;

export const CHECK_REQUIRED_PROFILE_FAILURE = 'CHECK_REQUIRED_PROFILE_FAILURE';
export type CHECK_REQUIRED_PROFILE_FAILURE = typeof CHECK_REQUIRED_PROFILE_FAILURE;

export const CHECK_REQUIRED_PROFILE_CLEAR = 'CHECK_REQUIRED_PROFILE_CLEAR';
export type CHECK_REQUIRED_PROFILE_CLEAR = typeof CHECK_REQUIRED_PROFILE_CLEAR;



// WEBPACK FOOTER //
// ./src/actions/user/requiredProfile/Types.tsx